const REDUX_STATE = "state";
const AUTHERIZAION_TOKEN = "AutherizationToken";
const SIDE_BAR_STATE = "sideBarState";
const SHOW_INSTRUCTIONS = "showInstructions";

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem(REDUX_STATE);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(REDUX_STATE, serializedState);
  } catch (err) {
    //log this
  }
};

export const saveToken = token => {
  try {
    localStorage.setItem(AUTHERIZAION_TOKEN, token);
  } catch (err) {
    //log this
  }
};

export const retrieveToken = () => {
  let token = localStorage.getItem(AUTHERIZAION_TOKEN);
  return !token || token == null || token === "" ? "sdjnsc" : token;
};

export const saveSideBarState = sideBarState => {
  try {
    localStorage.setItem(SIDE_BAR_STATE, sideBarState);
  } catch (err) {
    //log this
  }
};

export const retrieveSideBarState = () => {
  let sideBarState = localStorage.getItem(SIDE_BAR_STATE);
  return !sideBarState || sideBarState == null || sideBarState === ""
    ? null
    : sideBarState;
};

export const saveShowInstructions = showInstructions => {
  try {
    localStorage.setItem(SHOW_INSTRUCTIONS, showInstructions);
  } catch (err) {
    //log this
  }
};

export const retrieveShowInstructions = () => {
  let showInstructions = localStorage.getItem(SHOW_INSTRUCTIONS);
  let status =
    !showInstructions || showInstructions == null || showInstructions === ""
      ? "true"
      : showInstructions;
  return status === "true";
};
